module.exports = __webpack_public_path__ + "img/pingjia4.b82c2777.png";